<div class="protocol-mwst">
  <div class="protocol-mwst__header">
    <app-details-header
      [title]="headerTitle()"
      i18n-badgeText="@@details.protocolMwst.badgeText" badgeText="スクリーニング"
      [patientName]="patientName()"
      [measureDate]="measureDate()"
      [measurer]="measurer()" />
  </div>

  <div class="protocol-mwst__body">
    <!-- KPI Row: Score + Attempts + Criteria -->
    <div class="kpi-row kpi-row--thirds">
      <!-- Score Card -->
      <div class="kpi-card kpi-card--stat">
        <mat-icon class="kpi-card__watermark kpi-card__watermark--score">workspace_premium</mat-icon>
        <span class="kpi-card__title" i18n="@@details.protocolMwst.finalScoreLabel">最終スコア</span>
        <div class="kpi-card__main">
          <div class="kpi-card__value-row">
            @if (hasFinalScore()) {
              <span class="kpi-card__value">{{ finalScore() }}</span>
              <span class="kpi-card__suffix" i18n="@@details.protocolMwst.scoreSuffix">/ 5</span>
            } @else {
              <span class="kpi-card__value">—</span>
            }
          </div>
        </div>
      </div>

      <!-- Attempt Count Card -->
      <div class="kpi-card kpi-card--stat">
        <mat-icon class="kpi-card__watermark kpi-card__watermark--attempt">repeat</mat-icon>
        <span class="kpi-card__title" i18n="@@details.protocolMwst.attemptCountLabel">試行回数</span>
        <div class="kpi-card__main">
          <div class="kpi-card__value-row">
            <span class="kpi-card__value">{{ attemptCount() }}</span>
            <span class="kpi-card__suffix" i18n="@@details.protocolMwst.attemptSuffix">回</span>
          </div>
        </div>
      </div>

      <!-- Scoring Criteria Card -->
      <div class="kpi-card criteria-card">
        <span class="kpi-card__title" i18n="@@details.protocolMwst.criteriaLabel">評点基準</span>
        <!-- PC: 全5件 -->
        <ul class="criteria-list criteria-list--full">
          @for (item of mwstResults(); track item.value) {
            <li class="criteria-item" [class.criteria-item--selected]="item.selected">
              <span class="criteria-item__score">{{ item.value }}</span>
              <span class="criteria-item__desc">{{ item.description }}</span>
            </li>
          }
        </ul>
        <!-- Mobile: 該当±1の3件 -->
        <ul class="criteria-list criteria-list--nearby">
          @for (item of mwstResultsNearby(); track item.value) {
            <li class="criteria-item" [class.criteria-item--selected]="item.selected">
              <span class="criteria-item__score">{{ item.value }}</span>
              <span class="criteria-item__desc">{{ item.description }}</span>
            </li>
          }
        </ul>
      </div>
    </div>

    <!-- Attempt Detail Table (accordion) -->
    <div class="attempt-card">
      <button
        type="button"
        class="attempt-card__header"
        [attr.aria-expanded]="attemptsExpanded()"
        aria-controls="attempt-table-body"
        (click)="toggleAttempts()">
        <div class="attempt-card__header-left">
          <mat-icon class="attempt-card__icon">table_rows</mat-icon>
          <span class="attempt-card__title" i18n="@@details.protocolMwst.attemptDetailTitle">試行詳細</span>
        </div>
        <mat-icon class="attempt-card__chevron" [class.attempt-card__chevron--open]="attemptsExpanded()">
          expand_more
        </mat-icon>
      </button>

      @if (attemptsExpanded()) {
        <div id="attempt-table-body" class="attempt-card__table-wrap">
          <table class="attempt-card__table">
            <thead>
              <tr>
                <th i18n="@@details.protocolMwst.thTrial">試行</th>
                <th i18n="@@details.protocolMwst.thSwallow">嚥下の有無</th>
                <th i18n="@@details.protocolMwst.thCough">せき・むせの有無</th>
                <th i18n="@@details.protocolMwst.thRespiratory">呼吸変化</th>
                <th i18n="@@details.protocolMwst.thScore">評点</th>
              </tr>
            </thead>
            <tbody>
              @if (attemptsDetail().length) {
                @for (attempt of attemptsDetail(); track attempt.trial) {
                  <tr>
                    <td class="attempt-card__cell--trial">{{ attempt.trial }}</td>
                    <td>
                      <span
                        class="attempt-badge"
                        [class.attempt-badge--normal]="!attempt.swallowPresent"
                        [class.attempt-badge--abnormal]="attempt.swallowPresent">
                        {{ attempt.swallowLabel }}
                      </span>
                    </td>
                    <td>
                      <span
                        class="attempt-badge"
                        [class.attempt-badge--normal]="!attempt.coughPresent"
                        [class.attempt-badge--abnormal]="attempt.coughPresent">
                        {{ attempt.coughLabel }}
                      </span>
                    </td>
                    <td>
                      <span
                        class="attempt-badge"
                        [class.attempt-badge--normal]="!attempt.respiratoryWarning"
                        [class.attempt-badge--abnormal]="attempt.respiratoryWarning">
                        {{ attempt.respiratoryLabel }}
                      </span>
                    </td>
                    <td>
                      @if (attempt.hasInterimScore) {
                        <div class="score-indicator">
                          @for (dot of [1, 2, 3, 4, 5]; track dot) {
                            <span
                              class="score-indicator__dot"
                              [class.score-indicator__dot--active]="dot === attempt.interimScore"
                              [class.score-indicator__dot--high]="dot === attempt.interimScore && attempt.interimScore >= 4"
                              [class.score-indicator__dot--low]="dot === attempt.interimScore && attempt.interimScore <= 3">
                            </span>
                          }
                          <span class="score-indicator__label">{{ attempt.interimScore }}</span>
                        </div>
                      } @else {
                        <span class="attempt-card__empty-value">—</span>
                      }
                    </td>
                  </tr>
                }
              } @else {
                <tr>
                  <td class="attempt-card__empty-cell" colspan="5" i18n="@@details.protocolMwst.noAttemptData">試行データがありません</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>

    <!-- Wave + Posture + Event Timeline Card -->
    @if (showWaveCard()) {
      <div class="timeline-card">
        <div class="timeline-card__header">
          <div class="timeline-card__header-left">
            <mat-icon class="timeline-card__icon">graphic_eq</mat-icon>
            <span class="timeline-card__title">
              <span class="timeline-card__title-main" i18n="@@details.protocolMwst.waveTimelineTitle">波形タイムライン</span>
              <span class="timeline-card__title-detail" i18n="@@details.protocolMwst.waveTimelineSubtitle"> — 波形・姿勢・イベント</span>
            </span>
          </div>
          <span class="timeline-card__duration">
            <span i18n="@@details.protocolMwst.recordingDurationLabel">録音時間:</span> {{ recordData()?.data?.totalTime ?? '' }}
          </span>
        </div>

        <div class="timeline-card__grid">
          <div class="timeline-card__wave">
            <app-measured-data-wave-card
              [frameless]="true"
              [showMiniPlayback]="true"
              [recordData]="recordData()"
              [recordtype]="recordtype()"
              [recordLoadingSuccess]="recordLoadingSuccess()"
              [waveLoadingPercent]="waveLoadingPercent()"
              [waveErrorMessage]="waveErrorMessage()"
              [selectedEvent]="selectedEvent()"
              [currentStartOffset]="currentStartOffset()"
              [playing]="playing()"
              [timelineOffsetReference]="timelineOffsetReference()"
              [zoomValue]="zoomValue()"
              (offsetToggle)="offsetToggle.emit($event)"
              (seek)="seek.emit($event)"
              (playPauseClicked)="playPauseClicked.emit()"
              (zoomMinusClicked)="zoomMinusClicked.emit()"
              (zoomResetClicked)="zoomResetClicked.emit()"
              (zoomPlusClicked)="zoomPlusClicked.emit()" />
          </div>

          <div class="timeline-card__posture">
            <app-measured-data-neck-angle-card
              [frameless]="true"
              [chartOption]="chartOption()"
              [currentChartOption]="currentChartOption()"
              [currentOrientation]="currentOrientation()"
              (chartInit)="chartInit.emit($event)"
              (currentChartInit)="currentChartInit.emit($event)" />
          </div>

          <div class="timeline-card__events">
            <app-event-table
              [events]="events()"
              (seekToEvent)="onEventSeek($event)" />
          </div>

          <div class="timeline-card__footer">
            <app-data-footer
              [dataId]="dataId()"
              nbModel="nbModel v2.1"
              [downloadUrl]="downloadUrl()" />
          </div>
        </div>
      </div>
    }

    <!-- Reference Card -->
    <app-reference-card [searchLinks]="searchLinks()" />

    <!-- Disclaimer -->
    <app-disclaimer [message]="disclaimer()" />
  </div>
</div>
